<script>
	import { api } from '../api'
	export let item
	export let showStatus = true

	const devices = api.devices.store
	// this will suppress the console warnings 
	$$props

	$: device = $devices[item.id]
</script>

<div class='radioCard'>
	<header>
		<div>
			{#if device}
				<div>{device.name}</div>
				<div>{device.radioId}</div>
				<div>{device.radioType}</div>
				{#if showStatus && device.type === "GRS" && device.latitude === 0 && device.longitude === 0}
					<div class="gpsError">Invalid GPS</div>
				{/if}
			{:else}
				<div>Loading Device {item}...</div>
			{/if}
		</div>
		<!-- <img /> -->
	</header>
</div>

<style>
	.radioCard {
		margin-bottom:4px;
		cursor:pointer;
		border:2px solid lightgray;
		margin:4px;
		background-color: #ececec;
		color: black;
		margin: 8px;
	}

	.radioCard header div:nth-child(1) {
		font-size: 12pt;
		flex:1;
	}

	.radioCard header :not(div:first-child) {
		font-size: 10pt;
		margin-right:0.4rem;
		color:rgb(95, 95, 95);
	}

	.radioCard header div.gpsError {
		margin: 6px;
		color: rgb(255, 75, 75);
	}
</style>